import { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from '@wellesley/system-toast'
import useEventListener from 'hooks/useEventListener'
import { networkSlice } from '../../slices/networkSlice'

export function useNetworkStatusListener() {
  const dispatch = useDispatch()
  const toastId = useRef<number | string | null>(null)

  function dismissToast() {
    if (toastId.current) {
      toast.dismiss(toastId.current)
      toastId.current = null
    }
  }

  const setOnline = () => {
    dispatch(networkSlice.actions.setOnline(true))

    dismissToast()

    toastId.current = 'network-online'
    toast.success('Connection restored', { id: toastId.current })
  }

  const setOffline = () => {
    dispatch(networkSlice.actions.setOnline(false))

    dismissToast()

    toastId.current = 'network-offline'
    toast.error('Your network is unavailable', { id: toastId.current })
  }

  useEventListener('online', setOnline)
  useEventListener('offline', setOffline)
}
